import _ from 'lodash';
import type { HttpClient } from '@remodeling/base';
import {
  DeleteProcessReviewImageGatewayRequest,
  DeleteProcessReviewImageGatewayResponse,
  GetBestProcessReviewResponse,
  GetHomeOfTheMonthResponse,
  GetInteriorReviewDoneListRequest,
  GetInteriorReviewDoneListResponse,
  GetInteriorReviewOpenListRequest,
  GetInteriorReviewOpenListResponse,
  GetProcessFilterListGatewayResponse,
  GetProcessReviewWriteInfoGatewayRequest,
  GetProcessReviewWriteInfoGatewayResponse,
  GetSiteReviewWriteInfoGatewayRequest,
  GetSiteReviewWriteInfoGatewayResponse,
  PutProcessReviewWriteInfoGatewayRequest,
  PutSiteReviewWriteInfoGatewayRequest,
  GetProcessFilterListInfoRequest,
  GetProcessFilterListInfoResponse,
  GetInteriorReviewDetailGatewayRequest,
  GetInteriorReviewDetailGatewayResponse,
  InteriorReviewLikeRequest,
  GetInteriorReviewLikeResponse,
  PostInteriorReviewLikeResponse,
  DeleteInteriorReviewLikeResponse,
  GetBestProcessReviewRequest,
  GetProcessPhotoReviewResponse,
  GetProcessPhotoReviewRequest,
  GetInteriorReviewListRequest,
  GetInteriorReviewListResponse,
  GetShopDetailReviewRequest,
  GetShopDetailReviewResponse,
  GetExpertDetailReviewRequest,
  GetExpertDetailReviewResponse,
  GetRdStatisticsRequest,
  GetRdStatisticsResponse,
  GetShopStatisticRequest,
  GetShopStatisticResponse,
  GetShopCodeExistRequest,
  GetShopCodeExistResponse,
} from '../../model';

export class GetInteriorReviewOpenList {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetInteriorReviewOpenListRequest) {
    return await this.httpClient.request<GetInteriorReviewOpenListResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/open`,
      body: req,
    });
  }
}

export class GetInteriorReviewDoneList {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetInteriorReviewDoneListRequest) {
    return await this.httpClient.request<GetInteriorReviewDoneListResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/done`,
      body: req,
    });
  }
}

export class GetProcessReviewWriteInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetProcessReviewWriteInfoGatewayRequest) {
    return await this.httpClient.request<GetProcessReviewWriteInfoGatewayResponse>(
      {
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/${req.siteId}/processes/${req.processId}`,
      },
    );
  }
}

export class PutProcessReviewWriteInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: PutProcessReviewWriteInfoGatewayRequest) {
    return await this.httpClient.request<GetProcessReviewWriteInfoGatewayResponse>(
      {
        method: 'PUT',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/${req.siteId}/processes/${req.processId}`,
        body: _.omit(req, ['siteId', 'processId']),
      },
    );
  }
}

export class DeleteProcessReviewImageGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: DeleteProcessReviewImageGatewayRequest) {
    return await this.httpClient.request<DeleteProcessReviewImageGatewayResponse>(
      {
        method: 'DELETE',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/${req.siteId}/processes/${req.processId}/images/${req.intEvalProcImgId}`,
      },
    );
  }
}

// 공통 후기 조회
export class GetSiteReviewWriteInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetSiteReviewWriteInfoGatewayRequest) {
    return await this.httpClient.request<GetSiteReviewWriteInfoGatewayResponse>(
      {
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/${req.siteId}/common`,
      },
    );
  }
}

// 공통 후기 작성/수정
export class PutSiteReviewWriteInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: PutSiteReviewWriteInfoGatewayRequest) {
    return await this.httpClient.request<GetSiteReviewWriteInfoGatewayResponse>(
      {
        method: 'PUT',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/${req.siteId}/common`,
        body: _.omit(req, ['siteId']),
      },
    );
  }
}

// 상품 목록 필터 정보 조회
export class GetProcessFilterListInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(_req: GetProcessFilterListInfoRequest = {}) {
    return await this.httpClient.request<GetProcessFilterListInfoResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/filters`,
    });
  }
}

/**
 * 공정별 필터 목록
 */
export class GetProcessFilterListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec() {
    return await this.httpClient.request<GetProcessFilterListGatewayResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/processes/filters`,
    });
  }
}

/**
 * 상품별 베스트 후기
 */
export class GetBestProcessReviewGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetBestProcessReviewRequest) {
    return await this.httpClient.request<GetBestProcessReviewResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/processes/best-reviews`,
      body: req,
    });
  }
}

/**
 * 공정 상세
 */
export class GetInteriorReviewDetailGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetInteriorReviewDetailGatewayRequest) {
    return await this.httpClient.request<GetInteriorReviewDetailGatewayResponse>(
      {
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/${req.intEvalMstId}/processes/${req.intEvalProcId}/detail`,
      },
    );
  }
}

/**
 * 인테리어 후기 공정별 도움돼요
 */
export class GetInteriorReviewLikeGateway {
  constructor(private readonly httpClient: HttpClient) {}

  async exec({ intEvalMstId, intEvalProcId }: InteriorReviewLikeRequest) {
    return await this.httpClient.request<GetInteriorReviewLikeResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/${intEvalMstId}/processes/${intEvalProcId}/like`,
    });
  }
}

export class LikeInteriorReviewGateway {
  constructor(private readonly httpClient: HttpClient) {}

  async exec({ intEvalMstId, intEvalProcId }: InteriorReviewLikeRequest) {
    const url = `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/${intEvalMstId}/processes/${intEvalProcId}/like`;

    return await this.httpClient.request<PostInteriorReviewLikeResponse>({
      method: 'POST',
      url,
    });
  }
}

export class UnlikeInteriorReviewGateway {
  constructor(private readonly httpClient: HttpClient) {}

  async exec({ intEvalMstId, intEvalProcId }: InteriorReviewLikeRequest) {
    return await this.httpClient.request<DeleteInteriorReviewLikeResponse>({
      method: 'DELETE',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/${intEvalMstId}/processes/${intEvalProcId}/like`,
    });
  }
}

/**
 * 홈오브더모드 추천 후기
 */
export class GetHomeOfTheMonthGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec() {
    return await this.httpClient.request<GetHomeOfTheMonthResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/processes/home-of-the-month`,
    });
  }
}

/**
 * 인테리어 사진 후기 모아보기
 */
export class GetProcessPhotoEvaluationGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetProcessPhotoReviewRequest) {
    return await this.httpClient.request<GetProcessPhotoReviewResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/processes/photo-evaluation`,
      body: req,
    });
  }
}

/**
 * 인테리어 후기 목록
 */
export class GetInteriorReviewListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetInteriorReviewListRequest) {
    return await this.httpClient.request<GetInteriorReviewListResponse>({
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations`,
      body: req,
    });
  }
}

/**
 * 매장 상세 후기 조회
 */
export class GetShopDetailReviewGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetShopDetailReviewRequest) {
    return await this.httpClient.request<GetShopDetailReviewResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/shops/${req.sldToCd}/reviews`,
      body: _.omit(req, ['sldToCd']),
    });
  }
}

/**
 * 전문가 상세 후기 조회
 */
export class GetExpertDetailReviewGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetExpertDetailReviewRequest) {
    return await this.httpClient.request<GetExpertDetailReviewResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/rd/${req.agntStafCd}/reviews`,
      body: _.omit(req, ['agntStafCd']),
    });
  }
}

/**
 * RD 통계 정보 조회
 */
export class GetRdStatisticsGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetRdStatisticsRequest) {
    return await this.httpClient.request<GetRdStatisticsResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/rd/${req.agntStafCd}/statistics?typeValue=${req?.typeValue}`,
    });
  }
}

/**
 * 매장 통계 정보 조회
 */
export class GetShopStatisticsGateway {
  constructor(private readonly httpClient: HttpClient) {}
  async exec(req: GetShopStatisticRequest) {
    return await this.httpClient.request<GetShopStatisticResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/goods-service/api/v1/goods/interior-evaluations/shops/${req.sldToCd}/statistics`,
    });
  }
}

/**
 * 매장 아이디 존재 여부
 */
export class GetShopCodeExistGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetShopCodeExistRequest) {
    return await this.httpClient.request<GetShopCodeExistResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/shop-service/api/v1/shops/${req.shopCode}/exist`,
    });
  }
}
